<template>
<div class="pull">
    <van-pull-refresh v-model="pull.isLoading" @refresh="onRefresh">
        <van-list v-model="pull.loading" :finished="pull.finished" finished-text="— 已加载全部数据 —" @load="onLoad" :immediate-check="false"
                  :error.sync="pull.error" error-text="请求失败，点击重新加载">
            <slot></slot>
        </van-list>
    </van-pull-refresh>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'pull',
    data() {
        return {
        }
    },
    props: ['page', 'pull'],
    mounted() {
    },
    methods: {
        onRefresh() {
            if ($(document).scrollTop() === 0 || $(document).scrollTop() === '0') {
                this.setLoading(true)
                this.pull.finished = false
                this.page.page = 1
                this._getList()
            } else {
                this.pull.isLoading = false
            }
        },
        onLoad() {
            if (this.page.page < this.page.pageCount) {
                this.page.page++
                this._getList()
            } else {
                this.pull.finished = true
                this.pull.loading = false
            }
        },
        _getList () {
            this.$emit('getList')
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.pull {
    .van-list__finished-text{
       background: $c-global;
       background-color: #fff!important;
       font-size: 0.24rem!important;
       color: #999!important;
    }
}
</style>
